import { useState,useRef } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import * as ReactDOMServer from 'react-dom/server';
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import JSZip from 'jszip';

import GenericFullScreenPreview from "./GenericFullScreenPreview";
import EcommerceCarouselPreview from "./EcommerceCarouselPreview";
import EcommercePackshotPreview from "./EcommercePackshotPreview";
import AkedoGamePreview from "./AkedoGamePreview";

import  './preview.scss';
import Scrollbar from "../../Components/NewLayout/Scrollbar";



const TemplateDesignForm = (props: any) => {
  const { templateType,templateFields } = props;

  const [showBadge, setShowBadge] = useState(false);
  const [bannerType, setBannerType] = useState("html_file");

  const [title_font_color, setTitle_font_color] = useState("#343a40");
  const [subtitle_font_color, setSubtitle_font_color] = useState("#4b4b5a");
  const [close_btn_bg_color, setClose_btn_bg_color] = useState("#a5c7db");
  const [close_btn_fg_color, setClose_btn_fg_color] = useState("#ffffff");
  const [cta_btn_bg_color, setCta_btn_bg_color] = useState(templateType && templateType==='Template_Ecommerce_Carousel' ?"#fff":"#a5c7db");
  const [cta_btn_font_color, setCta_btn_font_color] = useState("#000");
  const [title_text, setTitle_text] = useState("");
  const [sub_title_text, setSub_title_text] = useState("");
  const [cta_btn_text, setCta_btn_text] = useState("");
  const [link_url, setLink_url] = useState("");

  const [product_desc_bg_color, setProduct_desc_bg_color] = useState("#a5c7db");
  const [product_desc_font_color, setProduct_desc_font_color] = useState("#000");
  const [carousel_bg_color,setCarousel_bg_color] = useState("#a5c7db");
  const [carousel_fg_color,setCarousel_fg_color] = useState("#ffffff");

  const [carousel_product_items,setCarousel_product_items] = useState<any>([
    {product_descriptor:'',product_url:'',product_image:''}
  ]);

  const [game_name,setGameName] = useState("");

  const [bgImageLink, setBgImageLink] = useState('');
  const [logoImageLink, setLogoImageLink] = useState('');
  const [mainImageVideoLink, setMainImageVideoLink] = useState('');
  const [ctaBtnIcnLink, setCtaBtnIcnLink] = useState('');
  const [badgeImgLink, setBadgeImgLink] = useState(''); 
  const [productItemImageLinks, setProductItemImageLinks] = useState<any>([]); //USED FOR E-commerce Carousel
  //const [tempUploadFiles,setTempUploadFiles]  = useState<any>([]);
  const [productitemTempIndex,setProductitemTempIndex] = useState('');

  const backgroundImageRef = useRef<HTMLInputElement>(null); 
  const logoImageRef = useRef<HTMLInputElement>(null);  
  const mainImageVideoRef = useRef<HTMLInputElement>(null);  
  const ctaIconImageRef = useRef<HTMLInputElement>(null);   
  const badgeIconRef = useRef<HTMLInputElement>(null);   
  const productItemImageRef = useRef<HTMLInputElement>(null);   
  //const dispatch = useDispatch();

  let initialValues = {
    background_image:'',
    logo_img:'',
    logo_main_img:'',
    logo_cta_button_icn:'',
    badge_image:'', 
    title_text: '', 
    sub_title_text: '', 
    cta_btn_text: '', 
    link_url: '',
    game_name:'',
    badge_switch:false
  };
   

  let schema;
  if(templateType==='Template_Generic'){
    schema = yup.object().shape({
      background_image: yup.string().required("background image required"),
      logo_img: yup.string().required("logo image required"),
      logo_main_img: yup.string().required("Main Image/Video required"),
      logo_cta_button_icn: yup.string().required("CTA Button Icon required"),
      badge_image: yup.string()
        .ensure().when('badge_switch', {
          is: true,
          then: yup.string()
          .required("Badge image required"), 
        }),
      title_text: yup.string().required("Title Text required"), 
      sub_title_text: yup.string().required("Sub-Title Text required"), 
      cta_btn_text: yup.string().required("CTA Button Text required"), 
      link_url: yup.string().required("Link URL required")
      .matches(
        /https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)(?::\d+)?(?![^<](?:<\/\w+>|\/?>))/,
        "Enter correct url!"
      ),
    })
  }else if(templateType==='Template_Ecommerce_Carousel'){
    schema = yup.object().shape({
      background_image: yup.string().required("background image required"),
      logo_img: yup.string().required("logo image required"),
      logo_cta_button_icn: yup.string().required("CTA Button Icon required"),
      title_text: yup.string().required("Title Text required"), 
      sub_title_text: yup.string().required("Sub-Title Text required"),
      cta_btn_text: yup.string().required("CTA Button Text required"),  
    })
  }else if(templateType==='Template_Akedo_Packshot'){
    schema = yup.object().shape({
      background_image: yup.string().required("background image required"),
      logo_img: yup.string().required("logo image required"),
      logo_main_img: yup.string().required("Main Image/Video required"),
      logo_cta_button_icn: yup.string().required("CTA Button Icon required"), 
      badge_image: yup.string()
        .ensure().when('badge_switch', {
          is: true,
          then: yup.string()
          .required("Badge image required"), 
      }),
      title_text: yup.string().required("Title Text required"), 
      sub_title_text: yup.string().required("Sub-Title Text required"), 
      cta_btn_text: yup.string().required("CTA Button Text required"), 
      link_url: yup.string().required("Link URL required")
      .matches(
        /https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)(?::\d+)?(?![^<](?:<\/\w+>|\/?>))/,
        "Enter correct url!"
      ),
    })
  } else if(templateType==='Template_Akedo_Game'){
    schema = yup.object().shape({
      background_image: yup.string().required("background image required"),
      logo_img: yup.string().required("logo image required"),
      logo_main_img: yup.string().required("Main Image/Video required"),
      logo_cta_button_icn: yup.string().required("CTA Button Icon required"),
      badge_image: yup.string()
        .ensure().when('badge_switch', {
          is: true,
          then: yup.string()
          .required("Badge image required"), 
      }),
      title_text: yup.string().required("Title Text required"), 
      game_name: yup.string().required("CTA Button Text required"), 
      link_url: yup.string().required("Link URL required")
      .matches(
        /https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)(?::\d+)?(?![^<](?:<\/\w+>|\/?>))/,
        "Enter correct url!"
      ),
    })
  }

  const base64ToBlob = (base64Data:any)=>{
    const dataUrl = base64Data;
    const newImageData = dataUrl.split(",")[1]; 
    const byteCharacters = atob(newImageData);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray]);
  }

  const handleDownloadBannerOld = (templateProperties:any,values:any ) => {
    try{ 
      let textHtml;
      if(templateType==='Template_Generic'){
        textHtml = ReactDOMServer.renderToString(<GenericFullScreenPreview templateProperties={templateProperties}  />); 
      }else if (templateType==='Template_Ecommerce_Carousel'){
        textHtml = ReactDOMServer.renderToString(<EcommerceCarouselPreview templateProperties={templateProperties}  />); 
      }else if (templateType==='Template_Akedo_Packshot'){
        textHtml = ReactDOMServer.renderToString(<EcommercePackshotPreview templateProperties={templateProperties}  />); 
      }else if (templateType==='Template_Akedo_Game'){
        textHtml = ReactDOMServer.renderToString(<AkedoGamePreview templateProperties={templateProperties}  />); 
      }else{
        textHtml = ReactDOMServer.renderToString(<GenericFullScreenPreview templateProperties={templateProperties}  />); 
      }
      let finalComponentHtml = `<!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>${templateType}</title>
          <!-- Include Bootstrap CSS (adjust the path as needed) -->
          <link href="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" rel="stylesheet">
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.2/dist/css/bootstrap.min.css" integrity="sha384-Zenh87qX5JnK2Jl0vWa8Ck2rdkQ2Bzep5IDxbcnCeuOxjzrPF/et3URy9Bv1WTRi" crossorigin="anonymous" /> 
          <style>
            a {
              text-decoration: none;
            }
            .bannerGenerat {
              text-align: center;
              width: 320px;
              height: 480px;
              margin: 35px auto 0;
              padding: 15px 55px 35px;
              position: relative;
           }
            .bannerGenerat .closeBtn {
              height: 35px;
              width: 35px;
              display: inline-block;
              position: absolute;
              top: -14px;
              right: -13px;
              line-height: 25px;
              text-indent: 0px;
              border-radius: 50%;
              font-size: 40px;
              transform: rotate(45deg);
              z-index: 99;
              cursor: pointer;
           }
            .bannerGenerat .logo {
              width: 120px;
              height: 60px;
              overflow: hidden;
              background-repeat: no-repeat;
              background-position: center center;
              background-size: contain;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              vertical-align: top;
           }
            .bannerGenerat .logo.akedogame {
              margin: 33px 0 0 0 !important;
           }
            .bannerGenerat .logo.akedogame img {
              max-width: 35px;
              margin-right: 5px;
           }
            .bannerGenerat .imgbox {
              position: relative;
              height: 290px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
           }
            .bannerGenerat .imgbox .badgeLogo {
              position: absolute;
              top: 40px;
              right: -50px;
              height: 130px;
              width: 130px;
              border-radius: 50%;
              overflow: hidden;
           }
            .bannerGenerat .imgbox .mainImg {
              max-width: 100%;
              max-height: 100%;
           }
            .bannerGenerat .imgbox .ctacart {
              padding: 6px 30px 6px 4px;
              position: absolute;
              bottom: -21px;
              border-radius: 30px;
              display: inline-flex;
              align-items: center;
           }
            .bannerGenerat .imgbox .ctacart span {
              height: 30px;
              width: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
              margin-right: 15px;
           }
            .bannerGenerat .imgbox .ctacart span svg {
              max-width: 15px;
           }
            .bannerGenerat .imgbox .imgslider {
              z-index: 999;
           }
            .bannerGenerat .imgbox .imgslider, .bannerGenerat .imgbox .imgslider div {
              height: 100%;
              width: 100%;
           }
            .bannerGenerat .imgbox .imgslider .mainImg, .bannerGenerat .imgbox .imgslider div .mainImg {
              height: 100%;
              width: 100%;
              object-fit: cover;
           }
            .bannerGenerat .imgbox .imgslider .productDescriptor, .bannerGenerat .imgbox .imgslider div .productDescriptor {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              text-align: left;
              display: flex;
              align-items: center;
              gap: 5px;
              justify-content: space-between;
              font-size: 14px;
              height: auto;
           }
            .bannerGenerat .imgbox .imgslider .productDescriptor .ctacart, .bannerGenerat .imgbox .imgslider div .productDescriptor .ctacart {
              position: relative;
              bottom: 0;
              padding: 2px 6px 2px 2px;
              font-size: 14px !important;
              width: auto;
           }
            .bannerGenerat .imgbox .imgslider .productDescriptor .ctacart span, .bannerGenerat .imgbox .imgslider div .productDescriptor .ctacart span {
              margin-right: 4px;
              height: 23px;
              width: 23px;
           }
            .bannerGenerat .imgbox .ctacart .icon {
              overflow: hidden;
              padding: 0px;
           }
            .bannerGenerat .imgbox .ctacart .icon img {
              height: 100%;
              width: 100%;
           }
            .bannerGenerat .imgbox .playNow .icon {
              overflow: hidden;
              padding: 10px;
           }
            .bannerGenerat .imgbox .playNow .icon img {
              height: 100%;
              width: 100%;
           }
            .bannerGenerat .carousel-indicators {
              display: none;
           }
            .bannerGenerat .carousel-control-prev {
              left: -17px;
              height: 40px;
              background: ${carousel_bg_color?carousel_bg_color:'#a5c7db'};
              width: 40px;
              border-radius: 50%;
              opacity: 1;
              top: 50%;
              transform: translateY(-50%);
              z-index: 999;
           }
            .bannerGenerat .carousel-control-next {
              right: -17px;
              height: 40px;
              background: ${carousel_bg_color?carousel_bg_color:'#a5c7db'};
              width: 40px;
              border-radius: 50%;
              opacity: 1;
              top: 50%;
              transform: translateY(-50%);
              z-index: 999;
           }
            .bannerGenerat .overlayLink {
              position: absolute;
              top: 0;
              left: 0;
              height: 100%;
              width: 100%;
              z-index: 9;
              font-size: 0;
           }
           .carousel-item{
              transition: -webkit-transform .0.5s ease;
              transition: transform .1s ease;
              transition: transform .1.5s ease,-webkit-transform .6s ease;
              background: no-repeat center center scroll;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              object-fit: cover !important; 
            }              
            </style>
      </head>
        <body>
          ${textHtml}
          <script src="https://code.jquery.com/jquery-3.5.1.slim.min.js"></script>
          <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.5.3/dist/umd/popper.min.js"></script>
          <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js"></script>
          <script> 
            $('#carosouleID').carousel();   
            $('.carousel-control-prev').click(function() {
                $('#carosouleID').carousel('prev');
            });
        
            $('.carousel-control-next').click(function() {
                $('#carosouleID').carousel('next');
            });
          </script>
        </body>
      </html>`;

      if(bannerType && bannerType==='html_file'){ 
        let data = new Blob([finalComponentHtml], {type: 'data:attachment/text,'});
        let csvURL = window.URL.createObjectURL(data);
        let tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download',  `${templateType}_Banner.html`);
        tempLink.click();
      }else{
        const zip = new JSZip();  
         const files:any = [];
        let newFinal =finalComponentHtml;
        
        if(bgImageLink){
          let bgImageBlob = base64ToBlob(bgImageLink); 
          if(bgImageBlob){
            files.push({ name: `images/BackgroundImage.png`, content: bgImageBlob }); 
            newFinal = finalComponentHtml.replace(bgImageLink, `'./images/BackgroundImage.png'`);  
          } 
        }
        if(logoImageLink){
          let logoImage = base64ToBlob(logoImageLink); 
          if(logoImage){
            files.push({ name: `images/logoImage.png`, content: logoImage });
            newFinal = newFinal.replace(logoImageLink, `'./images/logoImage.png'`);  
          } 
        }
        if(mainImageVideoLink){
          let mainImage = base64ToBlob(mainImageVideoLink); 
          if(mainImage){
            files.push({ name: `images/mainImage.png`, content: mainImage });
            newFinal = newFinal.replace(mainImageVideoLink, `./images/mainImage.png`);  
          } 
        }
        if(ctaBtnIcnLink){
          let ctaBtnIcn = base64ToBlob(ctaBtnIcnLink); 
          if(ctaBtnIcn){
            files.push({ name: `images/ctaBtnIcn.png`, content: ctaBtnIcn });
            newFinal = newFinal.replace(ctaBtnIcnLink, `./images/ctaBtnIcn.png`);   
          } 
        }
        if(badgeImgLink){
          let badgeImg = base64ToBlob(badgeImgLink); 
          if(badgeImg){
            files.push({ name: `images/badgeImg.png`, content: badgeImg });
            newFinal = newFinal.replace(badgeImgLink, `./images/badgeImg.png`);  

          } 
        }
        if(productItemImageLinks && productItemImageLinks.length >0 ){
          
          productItemImageLinks.map((x:any,index:any)=>{ 
             let productImage = base64ToBlob(x.product_image); 
            if(productImage){
              files.push({ name: `images/productImage_${index+1}.png`, content: productImage });
              newFinal = newFinal.replace(x.product_image, `./images/productImage_${index+1}.png`);   
            } 
            return x;
          })
        } 
        files.push({ name: `${templateType}_Banner.html`, content: newFinal })
        
        files.forEach((file:any) => {
          zip.file(file.name, file.content);
        });

        zip.generateAsync({ type: 'blob' }).then(function(blob) {
          const zipBlob = new Blob([blob]);
          const link = document.createElement('a');
          link.href = URL.createObjectURL(zipBlob);
          link.download = `${templateType}_Banner.zip`; // Set the desired ZIP file name
          link.click();
        }); 
      }
    }catch(err){
      //console.log('log error',err);
    }
  };

  /*const handleHtmlGenerateCallback =(res:any)=>{ 
    if(res?.background_image){
      setBgImageLink(res?.background_image);
    }
    if(res?.logo_img){
      setLogoImageLink(res?.logo_img);
    }
    if(res?.logo_main_img){
      setMainImageVideoLink(res?.logo_main_img);
    }
    if(res?.logo_cta_button_icn){
      setCtaBtnIcnLink(res?.logo_cta_button_icn);
    }
    if(res?.badge_image){
      setBadgeImgLink(res?.badge_image);
    }
    if(res?.product_item){
      setProductItemImageLinks(res?.product_item);
    }
  }
  const handleDownloadBanner = async (templateProperties:any,values:any ) => {
    const formData = new FormData()
    if(tempUploadFiles && tempUploadFiles.length > 1 ){
      await tempUploadFiles.forEach((e:any) => {
        formData.append(`${e.fieldName}`, e.file); 
      });
    }
    dispatch(UploadImageAction(formData,handleHtmlGenerateCallback))
  }; */

  const uploadImage=(event:any,field:any,setFormFieldValue:any)=>{ 
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    }
    
    const reader = new FileReader();
    reader.onload = (e:any) => { 
      if(field==='background_image'){
        setBgImageLink(e.target.result);
      }
      if(field==='logo_img'){
        setLogoImageLink(e.target.result);
      }
      if(field==='logo_main_img'){ 
        setMainImageVideoLink(e.target.result);
      }
      if(field==='logo_cta_button_icn'){ 
        setCtaBtnIcnLink(e.target.result);
      }
      if(field==='badge_image'){ 
        setBadgeImgLink(e.target.result);
      }
      if(field==='product_item'){
        let  tempProductLinks = carousel_product_items;
        tempProductLinks[productitemTempIndex].product_image =  e.target.result;
        setProductItemImageLinks(tempProductLinks);
        setProductitemTempIndex('');
      }
    };
    reader.readAsDataURL(fileObj);  

    // if(tempUploadFiles && tempUploadFiles.length > 0 ){  
    //   let index = tempUploadFiles.findIndex((e:any)=>e.fieldName===field);
    //   if(index>=0){
    //     let tempArr = tempUploadFiles;
    //     tempArr[index].file = fileObj;
    //     setTempUploadFiles([...tempArr]);
    //   }else{
    //     setTempUploadFiles([...tempUploadFiles,{'file':fileObj,'fieldName':field}])
    //   }
    // }else{ 
    //    setTempUploadFiles([...tempUploadFiles,{'file':fileObj,'fieldName':field}])
    // }
    setFormFieldValue(field,fileObj);
  }
  
  const handleUploadClick = (field:any)=>{
    if(field==='background_image'){
      if(backgroundImageRef){
        backgroundImageRef?.current?.click();
      }
    }else if(field==='logo_img'){
      if(logoImageRef){
        logoImageRef?.current?.click();
      }
    }else if(field==='logo_main_img'){
      if(mainImageVideoRef){
        mainImageVideoRef?.current?.click();
      }
    }else if(field==='logo_cta_button_icn'){
      if(ctaIconImageRef){
        ctaIconImageRef?.current?.click();
      }
    }else if(field==='badge_image'){
      if(badgeIconRef){
        badgeIconRef?.current?.click();
      }
    }else if(field==='product_item'){
      if(productItemImageRef){ 
        productItemImageRef?.current?.click();
      }
    }
  } 

  let templateProperties = {
    showBadge,
    title_font_color,
    subtitle_font_color,
    close_btn_bg_color,
    close_btn_fg_color,
    cta_btn_bg_color,
    cta_btn_font_color,
    title_text,
    sub_title_text,
    cta_btn_text,
    link_url,
    carousel_bg_color,
    carousel_fg_color,
    carousel_product_items,
    game_name,
    bgImageLink,
    logoImageLink,
    mainImageVideoLink,
    ctaBtnIcnLink,
    badgeImgLink,
    productItemImageLinks,
    product_desc_bg_color,
    product_desc_font_color
  }

  let formTitle = 'GENERIC FULL SCREEN';
  if(templateType==='Template_Ecommerce_Carousel'){
    formTitle = 'E-COMMERCE CAROUSEL';
  }else if(templateType==='Template_Akedo_Packshot'){
    formTitle = 'E-COMMERCE PACKSHOT';
  }else if(templateType==='Template_Akedo_Game'){
    formTitle = 'AKEDO GAME';
  } 

 
  return (
    <>
      {templateType && (
        <>
          <Row>
            <Col lg={6}>
              <Scrollbar
                style={{ maxHeight: '685px' }}
                className="" 
              >
              <Card>
                <Card.Body>
                  <h4 className="header-title mt-0 mb-2">{formTitle}</h4>
                  <Formik
                    validationSchema={schema}
                    onSubmit={(values) => { 
                      //handleDownloadBanner(templateProperties,values)
                      handleDownloadBannerOld(templateProperties,values)
                    }}
                    initialValues={initialValues}
                  >
                    {({
                      handleSubmit,
                      handleChange,
                      values,
                      touched,
                      errors,
                      resetForm,
                      setFieldValue,
                      handleBlur,initialTouched
                    }) => (
                      //console.log('log errors',errors,touched,initialTouched),
                      <Form noValidate onSubmit={handleSubmit} key={`form_${templateType}`}>
                        <Row>
                          {templateFields.includes("background_image") && (
                            <>
                              <input
                                ref={backgroundImageRef}
                                style={{display: 'none'}}
                                type="file"
                                name={'background_image'}
                                onChange={(e)=>uploadImage(e,'background_image',setFieldValue)}
                              />
                              <Col md={12}>
                                <Form.Group className="mb-3">
                                  <Form.Label htmlFor="background_image">
                                    Background Image
                                  </Form.Label>
                                  <br />
                                  <Button style={{ margin: "0" }} variant="info" onClick={()=>handleUploadClick('background_image')} >
                                    Upload Image
                                  </Button>
                                   {errors?.background_image && <span style={{color: "#dc3545",fontFamily: "Silka", fontSize: 12,paddingLeft:10 }} >{errors?.background_image}</span>}
                                </Form.Group>
                              </Col>
                            </>
                          )}
                          {templateFields.includes("title_font_color") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="title_font_color">
                                  Title Font Color
                                </Form.Label>
                                <Form.Control
                                  id="template-title_font_color"
                                  type="color"
                                  name="title_font_color"
                                  className="w-100"
                                  defaultValue={title_font_color}
                                  onChange={(e: any) =>
                                    setTitle_font_color(e.target.value)
                                  }
                                />
                              </Form.Group>
                            </Col>
                          )}

                          {templateFields.includes("subtitle_font_color") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="subtitle_font_color">
                                  Subtitle Font Color
                                </Form.Label>
                                <Form.Control
                                  id="template-subtitle_font_color"
                                  type="color"
                                  name="subtitle_font_color"
                                  className="w-100"
                                  defaultValue={subtitle_font_color}
                                  onChange={(e: any) =>
                                    setSubtitle_font_color(e.target.value)
                                  }
                                />
                              </Form.Group>
                            </Col>
                          )}

                          {templateFields.includes("close_btn_bg_color") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="close_btn_bg_color">
                                  Close Button Background Color
                                </Form.Label>
                                <Form.Control
                                  id="template-close_btn_bg_color"
                                  type="color"
                                  name="close_btn_bg_color"
                                  className="w-100"
                                  defaultValue={close_btn_bg_color}
                                  onChange={(e: any) =>
                                    setClose_btn_bg_color(e.target.value)
                                  }
                                />
                              </Form.Group>
                            </Col>
                          )}

                          {templateFields.includes("close_btn_fg_color") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="close_btn_fg_color">
                                  Close Button Foreground Color
                                </Form.Label>
                                <Form.Control
                                  id="template-close_btn_fg_color"
                                  type="color"
                                  name="close_btn_fg_color"
                                  className="w-100"
                                  defaultValue={close_btn_fg_color}
                                  onChange={(e: any) =>
                                    setClose_btn_fg_color(e.target.value)
                                  }
                                />
                              </Form.Group>
                            </Col>
                          )}
                          {templateFields.includes("product_desc_bg_color") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="product_desc_bg_color">
                                  Product Descriptor Background Color
                                </Form.Label>
                                <Form.Control
                                  id="template-product_desc_bg_color"
                                  type="color"
                                  name="product_desc_bg_color"
                                  className="w-100"
                                  defaultValue={product_desc_bg_color}
                                  onChange={(e: any) =>
                                    setProduct_desc_bg_color(e.target.value)
                                  }
                                />
                              </Form.Group>
                            </Col>
                          )}
                          {templateFields.includes(
                            "product_desc_font_color"
                          ) && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="product_desc_font_color">
                                  Product Descriptor Text Color
                                </Form.Label>
                                <Form.Control
                                  id="template-product_desc_font_color"
                                  type="color"
                                  name="product_desc_font_color"
                                  className="w-100"
                                  defaultValue={product_desc_font_color}
                                  onChange={(e: any) =>
                                    setProduct_desc_font_color(e.target.value)
                                  }
                                />
                              </Form.Group>
                            </Col>
                          )}

                          {templateFields.includes("cta_btn_bg_color") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="cta_btn_bg_color">
                                  CTA Button Background Color
                                </Form.Label>
                                <Form.Control
                                  id="template-cta_btn_bg_color"
                                  type="color"
                                  name="cta_btn_bg_color"
                                  className="w-100"
                                  defaultValue={cta_btn_bg_color}
                                  onChange={(e: any) =>
                                    setCta_btn_bg_color(e.target.value)
                                  }
                                />
                              </Form.Group>
                            </Col>
                          )}

                          {templateFields.includes("cta_btn_font_color") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="cta_btn_font_color">
                                  CTA Button Font Color
                                </Form.Label>
                                <Form.Control
                                  id="template-cta_btn_font_color"
                                  type="color"
                                  name="cta_btn_font_color"
                                  className="w-100"
                                  defaultValue={cta_btn_font_color}
                                  onChange={(e: any) =>
                                    setCta_btn_font_color(e.target.value)
                                  }
                                />
                              </Form.Group>
                            </Col>
                          )}

                          {templateFields.includes("carousel_bg_color") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="carousel_bg_color">
                                  Carousel Button Background Color
                                </Form.Label>
                                <Form.Control
                                  id="template-carousel_bg_color"
                                  type="color"
                                  name="carousel_bg_color"
                                  className="w-100"
                                  defaultValue={carousel_bg_color}
                                  onChange={(e: any) =>
                                    setCarousel_bg_color(e.target.value)
                                  }
                                />
                              </Form.Group>
                            </Col>
                          )}

                          {templateFields.includes("carousel_fg_color") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="carousel_fg_color">
                                  Carousel Button Foreground Color
                                </Form.Label>
                                <Form.Control
                                  id="template-carousel_fg_color"
                                  type="color"
                                  name="carousel_fg_color"
                                  className="w-100"
                                  defaultValue={carousel_fg_color}
                                  onChange={(e: any) =>
                                    setCarousel_fg_color(e.target.value)
                                  }
                                />
                              </Form.Group>
                            </Col>
                          )}

                          {templateFields.includes("logo_img") && (
                            <>
                              <input
                                ref={logoImageRef}
                                style={{display: 'none'}}
                                type="file"
                                name={'logo_image'}
                                onChange={(e)=>uploadImage(e,'logo_img',setFieldValue)}
                              />
                              <Col md={12}>
                                <Form.Group className="mb-3">
                                  <Form.Label htmlFor="logo_img">
                                    Logo Image
                                  </Form.Label>
                                  <br />
                                  <Button style={{ margin: "0" }} variant="info" onClick={()=>handleUploadClick('logo_img')} >
                                    Upload Image
                                  </Button>
                                  {errors?.logo_img && <span style={{color: "#dc3545",fontFamily: "Silka", fontSize: 12,paddingLeft:10 }} >{errors?.logo_img}</span>}
                                </Form.Group>
                              </Col> 
                            </>
                          )}
                          {templateFields.includes("logo_main_img") && (
                            <>
                              <input
                                ref={mainImageVideoRef}
                                style={{display: 'none'}}
                                type="file"
                                name={'logo_main_img'}
                                onChange={(e)=>uploadImage(e,'logo_main_img',setFieldValue)}

                              />
                              <Col md={12}>
                                <Form.Group className="mb-3">
                                  <Form.Label htmlFor="logo_main_img">
                                    Main Image/Video
                                  </Form.Label>
                                  <br />
                                  <Button style={{ margin: "0" }} variant="info"  onClick={()=> handleUploadClick('logo_main_img')}>
                                    Upload Image
                                  </Button>
                                  {errors?.logo_main_img && <span style={{color: "#dc3545",fontFamily: "Silka", fontSize: 12,paddingLeft:10 }} >{errors?.logo_main_img}</span>}
                                </Form.Group>
                              </Col> 
                            </>
                          )}
                          {templateFields.includes("logo_cta_button_icn") && (
                            <>
                              <input
                                ref={ctaIconImageRef}
                                style={{display: 'none'}}
                                type="file"
                                name={'logo_cta_button_icn'} 
                                onChange={(e)=>uploadImage(e,'logo_cta_button_icn',setFieldValue)} 
                              />
                              <Col md={12}>
                                <Form.Group className="mb-3">
                                  <Form.Label htmlFor="logo_cta_button_icn">
                                    CTA Button Icon
                                  </Form.Label>
                                  <br />
                                  <Button style={{ margin: "0" }} variant="info" onClick={()=> handleUploadClick('logo_cta_button_icn')}>
                                    Upload Image
                                  </Button>
                                  {errors?.logo_cta_button_icn && <span style={{color: "#dc3545",fontFamily: "Silka", fontSize: 12,paddingLeft:10 }} >{errors?.logo_cta_button_icn}</span>}
                                </Form.Group>
                              </Col>
                            </>
                          )}

                          {templateFields.includes("title_text") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="title_text">
                                  Title Text
                                </Form.Label>
                                <Form.Control
                                  id="template-title_text"
                                  type="text"
                                  name="title_text"
                                  className="w-100"
                                  defaultValue={title_text}
                                  onChange={(e)=>{
                                    handleChange(e);
                                    setTitle_text(e.target.value);
                                  }}
                                  onBlur={handleBlur}
                                />
                                {errors?.title_text && <span style={{color: "#dc3545",fontFamily: "Silka", fontSize: 12 }} >{errors?.title_text}</span>}
                              </Form.Group> 
                            </Col>
                          )}
                          {templateFields.includes("sub_title_text") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="sub_title_text">
                                  Subtitle Text
                                </Form.Label>
                                <Form.Control
                                  id="template-sub_title_text"
                                  type="text"
                                  name="sub_title_text"
                                  className="w-100"
                                  defaultValue={sub_title_text}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setSub_title_text(e.target.value)
                                  }}
                                  onBlur={handleBlur}
                                />
                                {errors?.sub_title_text && <span style={{color: "#dc3545",fontFamily: "Silka", fontSize: 12 }} >{errors?.sub_title_text}</span>}
                              </Form.Group>
                            </Col>
                          )}
                          {templateFields.includes("cta_btn_text") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="cta_btn_text">
                                  CTA Button Text
                                </Form.Label>
                                <Form.Control
                                  id="template-cta_btn_text"
                                  type="text"
                                  name="cta_btn_text"
                                  className="w-100"
                                  defaultValue={cta_btn_text}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setCta_btn_text(e.target.value)
                                  }}
                                  onBlur={handleBlur}
                                />
                                {errors?.cta_btn_text && <span style={{color: "#dc3545",fontFamily: "Silka", fontSize: 12 }} >{errors?.cta_btn_text}</span>} 
                              </Form.Group>
                            </Col>
                          )}
                          {templateFields.includes("game_name") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="game_name">
                                  Game Name
                                </Form.Label>
                                <Form.Control
                                  id="template-game_name"
                                  type="text"
                                  name="game_name"
                                  className="w-100"
                                  defaultValue={game_name}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setGameName(e.target.value) 
                                  }}
                                  onBlur={handleBlur}
                                />
                                {errors?.game_name && <span style={{color: "#dc3545",fontFamily: "Silka", fontSize: 12 }} >{errors?.game_name}</span>} 
                              </Form.Group>
                            </Col>
                          )}
                          {templateFields.includes("link_url") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label htmlFor="link_url">URL</Form.Label>
                                <Form.Control
                                  id="template-link_url"
                                  type="text"
                                  name="link_url"
                                  className="w-100"
                                  defaultValue={link_url}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setLink_url(e.target.value)
                                  }}
                                  onBlur={handleBlur}
                                />
                                {errors?.link_url && <span style={{color: "#dc3545",fontFamily: "Silka", fontSize: 12 }} >{errors?.link_url}</span>} 
                              </Form.Group>
                            </Col>
                          )}
                          {templateFields.includes("switch_badge") && (
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Check
                                  type="switch"
                                  id="custom-switch"
                                  label="Show Badge"
                                  checked={showBadge}
                                  name="badge_switch"
                                  onChange={(e: any) => {
                                    setShowBadge(e.target.checked);
                                    setFieldValue('badge_switch',e.target.checked);
                                  }}
                                />
                              </Form.Group>
                            </Col>
                          )}
                          {templateFields.includes("badge_image") && (
                            <>
                              <input
                                ref={badgeIconRef}
                                style={{display: 'none'}}
                                type="file"
                                name={'badge_image'}
                                onChange={(e)=>uploadImage(e,'badge_image',setFieldValue)} 

                              />
                              <Col md={12}>
                                <Form.Group className="mb-3">
                                  <Form.Label htmlFor="badge_image">
                                    Badge Image
                                  </Form.Label>
                                  <br />
                                  <Button style={{ margin: "0" }} variant="info" onClick={()=> handleUploadClick('badge_image')}>
                                    Upload Image
                                  </Button>
                                  {errors?.badge_image && <span style={{color: "#dc3545",fontFamily: "Silka", fontSize: 12,paddingLeft:10 }} >{errors?.badge_image}</span>}
                                </Form.Group>
                              </Col>
                            </>
                          )}

                          {templateFields.includes("product_item") && (
                            <>
                              <input
                                ref={productItemImageRef}
                                style={{display: 'none'}}
                                type="file" 
                                onChange={(e)=>uploadImage(e,'product_item',setFieldValue)}  
                              />
                               <hr style={{  height: 5 }} />
                              <Col md={12}>
                                <Button
                                  style={{ marginLeft: "0" ,color:'#ffff' }}
                                  variant="warning"
                                  onClick={()=>setCarousel_product_items([...carousel_product_items,{product_descriptor:'',product_url:'',product_image:''}])}
                                >
                                  + Add Item
                                </Button>
                              </Col>
                              {carousel_product_items.map((x: any,index:any) => {
                                return (
                                <>
                                  <Col md={12} key={`product_item_${index}`}>
                                    <Form.Group className="mb-3">
                                      <Form.Label htmlFor="product_descriptor">
                                        Item #{index+1} : Product Descriptor
                                      </Form.Label>
                                      <Form.Control
                                        id="template-product_descriptor"
                                        type="text"
                                        name="product_descriptor"
                                        className="w-100"
                                        defaultValue={x.product_descriptor}
                                        onChange={(e) => {
                                          let temp:any = carousel_product_items;
                                          temp[index].product_descriptor = e.target.value;
                                          setCarousel_product_items(temp);
                                        }}
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md={12}>
                                    <Form.Group className="mb-3">
                                      <Form.Label htmlFor="product_url">
                                        Item #{index+1} : URL
                                      </Form.Label>
                                      <Form.Control
                                        id="template-product_url"
                                        type="text"
                                        name="product_url"
                                        className="w-100"
                                        defaultValue={x.product_url}
                                        onChange={(e) => {
                                          let temp:any = carousel_product_items;
                                          temp[index].product_url = e.target.value;
                                          setCarousel_product_items(temp);
                                        }}
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md={12}>
                                      <Form.Group className="mb-3">
                                        <Form.Label htmlFor="logo_cta_button_icn">
                                        Item #{index+1} : Main Image / Video
                                        </Form.Label>
                                        <br />
                                        <Button style={{ margin: "0" }} variant="info"  onClick={()=> {
                                          setProductitemTempIndex(index);
                                          handleUploadClick('product_item');
                                        }} >
                                          Upload Image
                                        </Button>
                                      </Form.Group>
                                  </Col>
                                  </>
                                )
                              })}

                              <Col md={12}>
                                <Button
                                  style={{ marginLeft: "0",color:'#ffff' }}
                                  variant="danger"
                                  onClick={()=>{
                                    if(carousel_product_items && carousel_product_items.length > 1){
                                      const copyArr = [...carousel_product_items];
                                      copyArr.pop();
                                      setCarousel_product_items(copyArr); 

                                      if(productItemImageLinks && productItemImageLinks.length > 1){
                                        const newProductArr = [...productItemImageLinks];
                                        newProductArr.pop();
                                        setProductItemImageLinks(newProductArr); 
                                      }
                                    }
                                  }}

                                >
                                  Delete Item
                                </Button>
                              </Col>
                              <hr style={{  height: 5 }} />
                            </>
                          )}
                          
                          <Col md={12}>
                            <Form.Group className="mb-3">
                              <Form.Label htmlFor="badge_image">
                                Banner Type
                              </Form.Label>
                              <div className="">
                                <Row>
                                  <Col lg={12}>
                                    <Form.Check
                                      type="radio"
                                      name="HTML file only"
                                      onChange={() =>setBannerType("html_file")}
                                      value="html_file"
                                      checked={bannerType === "html_file"? true: false}
                                      label={'HTML file only'}
                                      className="mb-1"
                                    /> 
                                  </Col>
                                  <Col lg={12}>
                                    <Form.Check
                                      type="radio"
                                      name="ZIP File with all assets"
                                      value="zip_file"
                                      onChange={() => setBannerType("zip_file")}
                                      checked={bannerType === "zip_file" ? true : false}
                                      label={'ZIP File with all assets'} 
                                      className="mb-1"
                                    /> 
                                  </Col>
                                </Row>
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12}>
                            <Button
                              style={{ marginLeft: "0", fontWeight: "700" }}
                              variant="primary"
                              type="submit" 
                              disabled={Object.keys(errors).length >0 ? true: Object.keys(touched).length < 1  ? true :false }
                            >
                              Generate HTML5 Banner
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                </Card.Body>
              </Card>
              </Scrollbar>
            </Col>
            <Col lg={6}>
              <Card style={{ height: '685px' }}>
                <Card.Body>
                  <h4 className="header-title mt-0">PREVIEW</h4>
                  {templateType === "Template_Generic" && (
                    <GenericFullScreenPreview
                      templateProperties={templateProperties}
                    />
                  )}
                  {templateType === "Template_Ecommerce_Carousel" && (
                    <EcommerceCarouselPreview
                      templateProperties={templateProperties}
                    />
                  )}
                  {templateType === "Template_Akedo_Packshot" && (
                    <EcommercePackshotPreview
                      templateProperties={templateProperties}
                    />
                  )}
                  {templateType === "Template_Akedo_Game" && (
                    <AkedoGamePreview templateProperties={templateProperties} />
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default TemplateDesignForm;
